import { _boardDenorm } from './helpers/boardDenorm';

export const getBoardDenorm = (response) => {
  if (typeof response === 'object') {
    return _boardDenorm(response);
  }
  return response;
};
